import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { GetServerSideProps } from 'next'
import { AllProducts } from 'features/ECommerce/screens/AllProducts'
import { prefetchFetchProducts } from 'features/ECommerce/api/queries/useFetchProducts'

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const dehydratedState = await prefetchFetchProducts({
    page: 1,
    limit: 10,
    proteins: [],
    types: [],
    textSearch: '',
  })

  return {
    props: {
      ...dehydratedState,
    },
  }
}

export default function Products() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('e-commerce:page-title')}</title>
        <meta name="title" content={t('e-commerce:meta-title')} />
        <meta name="description" content={t('e-commerce:meta-description')} />
      </Head>

      <main>
        <AllProducts />
      </main>
    </div>
  )
}
